import { Input, toAbsoluteUrl } from "sr/helpers";
import { Link, useNavigate } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import { useFormik } from "formik";
import { useState } from "react";
import { authSchema } from "sr/utils/schemas/authSchema";
import { login } from "sr/utils/api/login";
import { toast } from "react-toastify";
import { ButtonAuth } from "sr/helpers/ui-components/ButtonAuth";
import { useAuth } from "./core/Auth";
import { SuccessMessage } from "sr/helpers/functions/SuccessMessage";
import { getAvailability } from "sr/utils/api/cleaner/getAvailability";
import { getCleaner } from "sr/utils/api/cleaner/getCleaner";
import { getIndIntersted } from "sr/utils/api/cleaner/indInterested/getIndIntersted";
import { setRegionIdMe } from "sr/helpers/functions/setCityMe";
import { getUserFullProfile } from "sr/utils/api/user/user";
export default function SigninPage() {
  const [username, setUsername] = useState();
  const [password, setPassword] = useState();
  const [loader, setLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const { persistToken } = useAuth();
  const initialValues = {
    username: username,
    password: password,
  };
  const intl = useIntl();
  const { handleChange, submitForm, handleSubmit, errors } = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: authSchema,
    onSubmit: async (values) => {
      try {
        setLoader(true);
        const result = await login(values);
        if (result.success === true) {
          setLoader(false);
          const returnType = result.data.user.type;
          const data = {
            userType: result?.data?.user.type,
            user_id: result?.data?.auth.user_id,
          };
          if (returnType) {
            SuccessMessage("API.SUCCESS.LOGIN");
            localStorage.setItem("auth", JSON.stringify(data));
            persistToken(
              result?.data?.auth.jwt,
              result?.data?.auth?.onBoardingStatus ?? result?.data?.onBoardingStatus
            );
            const rawRegionId = result?.data?.user?.regionId;
            let regionId =
              typeof rawRegionId === "object"
                ? rawRegionId?.id || rawRegionId?._id || null
                : rawRegionId || null;
            if (
              !regionId &&
              (returnType === "cleaner" || returnType === "individual")
            ) {
              const userProfile = await getUserFullProfile();
              const sharedRegion = userProfile?.data?.regions?.[0]?.regionId;
              regionId =
                typeof sharedRegion === "object"
                  ? sharedRegion?.id || sharedRegion?._id || null
                  : sharedRegion || null;
            }
            setRegionIdMe(regionId);
            switch (returnType) {
              case "company":
                navigate("/jobs-listing");
                break;
              case "supervisor":
                navigate("/supervisor/work-order");
                break;
              case "corporate":
                navigate("/corporate/requirement-listing");
                break;
              case "cleaner":
                try {
                  const userId = result?.data?.auth.user_id;

                  const queryParams = new URLSearchParams({
                    cleaner_id: userId,
                  });
                  const cleanerParams = new URLSearchParams({ id: userId });

                  const [availabilityRes, cleanerRes, resInterested] =
                    await Promise.all([
                      getAvailability(queryParams),
                      getCleaner(cleanerParams),
                      getIndIntersted(queryParams),
                    ]);

                  const hasAvailability =
                    availabilityRes?.success &&
                    availabilityRes?.data &&
                    availabilityRes.data.length > 0;
                  const hasCleaner =
                    cleanerRes?.success &&
                    cleanerRes?.data &&
                    cleanerRes.data.address &&
                    !!cleanerRes.data.address.address_line_1;

                  if (hasAvailability && hasCleaner) {
                    navigate("/cleaner-jobs");
                  } else if (!hasAvailability && hasCleaner) {
                    if (!resInterested?.success) {
                      navigate("/cleaner-profile?tab=5");
                    } else if (resInterested?.data?.interested === false) {
                      navigate("/cleaner-jobs");
                    } else {
                      navigate("/cleaner-profile?tab=6");
                    }
                  } else {
                    navigate("/cleaner-profile");
                  }
                } catch (e) {
                  console.error("Error in cleaner availability check:", e);
                  navigate("/cleaner-profile");
                }
                break;
              case "individual":
                navigate("/individual/jobs");
                break;
            }
          } else {
            toast.error("Your Details are incorrect");
            setLoader(false);
          }
        } else {
          setLoader(false);
          switch (result.msg) {
            case "USER.IS.DELETED":
              toast.error("User has been deleted.");
              break;

            default:
              toast.error(
                result?.error?.message || "Your details are incorrect.",
              );
              break;
          }
        }
      } catch (e: any) {
        setLoader(false);
      }
    },
  });
  return (
    <>
      {/* <AuthNavComponent isLoginPage={true}></AuthNavComponent> */}
      <main>
        <div className="lg:container mx-auto lg:max-w-3xl lg:mt-24 mt-8 px-4 lg:px-0">
          <div className="h-fit lg:mx-12 block p-6 bg-white border border-gray-border rounded-xl">
            <div className="flex justify-center">
              <Link to="/" className="z-50">
                <img
                  width={150}
                  src={toAbsoluteUrl("/media/logos/logo2.png")}
                  alt=""
                  className="bg-white rounded-lg"
                />
              </Link>
            </div>
            <div className="mt-10 text-center">
              <h1 className="mt-10 text-center text-3xl font-bold bg-gradient-to-r from-blue-500 to-cyan-500 bg-clip-text text-transparent">
                Welcome Back
              </h1>
              <p className="text-sm text-gray-500 mt-1">
                Please sign in to your account
              </p>
            </div>
            <form onSubmit={handleSubmit}>
              <Input
                onChange={(e) => setUsername(e.target.value)}
                label={intl.formatMessage({
                  id: "AUTH.INPUT.USERNAME.OR.EMAIL",
                  defaultMessage: "Enter Username",
                })}
                type="text"
                value={username}
                error={errors.username}
                placeholder={intl.formatMessage({
                  id: "AUTH.LOGIN.INPUT.USERNAME.OR.EMAIL.PLACEHOLDER",
                  defaultMessage: "Enter your username",
                })}
              ></Input>
              <div className="relative">
                <Input
                  onChange={(e) => setPassword(e.target.value)}
                  label={intl.formatMessage({
                    id: "AUTH.INPUT.PASSWORD",
                    defaultMessage: "Password",
                  })}
                  placeholder={intl.formatMessage({
                    id: "AUTH.LOGIN.INPUT.PASSWORD.PLACEHOLDER",
                    defaultMessage: "Enter your password",
                  })}
                  value={password}
                  type={showPassword ? "text" : "password"}
                  error={errors.password}
                ></Input>
                <div className="absolute top-[38px] right-2 ">
                  {showPassword ? (
                    <svg
                      onClick={() => setShowPassword(false)}
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="size-6 cursor-pointer"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                      />
                    </svg>
                  ) : (
                    <svg
                      onClick={() => setShowPassword(true)}
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="size-6 cursor-pointer"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
                      />
                    </svg>
                  )}
                </div>
              </div>
              <div className="mt-2 flex justify-end">
                <Link
                  to={"/forget-password"}
                  className="cursor-pointer hover:text-pink underline float-right"
                >
                  <FormattedMessage
                    id="AUTH.FORGOT.TITLE"
                    defaultMessage="Forgot Password?"
                  />
                </Link>
              </div>
              <div className="mt-5 flex space-x-10 justify-center">
                <div>
                  <ButtonAuth
                    loader={loader}
                    onClick={() => {
                      submitForm();
                    }}
                  >
                    Login
                  </ButtonAuth>
                </div>
              </div>
            </form>
            <div className="mt-5 flex items-center justify-center px-10">
              <div className="border text-center px-3 py-2 rounded-full hover:border-[#0078ae] text-[#0078ae] text-base font-bold">
                <Link to="/register">
                  <FormattedMessage
                    id="AUTH.GENERAL.REGISTER.CTA"
                    defaultMessage="Register"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
